document.addEventListener('DOMContentLoaded', () => {
  const productList = document.querySelector('[id^="product-list-"]');
  const paginationWrapper = document.querySelector('#collection-pagination');
  const loadingIndicator = document.querySelector('#collection-loading');
  let loading = false;
  let canLoad = true;

  const loadNextPage = () => {
    const nextLink = paginationWrapper.querySelector('a[rel="next"]');
    if (!nextLink) {
      canLoad = false;
      return;
    }

    loading = true;
    loadingIndicator.style.display = 'block';

    fetch(nextLink.href)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Append new product cards
        const newItems = doc.querySelectorAll('.product-card');
        newItems.forEach(item => productList.appendChild(item));

        // Replace pagination HTML for future scroll
        const newPagination = doc.querySelector('#collection-pagination').innerHTML;
        paginationWrapper.innerHTML = newPagination;
      })
      .finally(() => {
        loading = false;
        loadingIndicator.style.display = 'none';
      });
  };

  window.addEventListener('scroll', () => {
    if (!loading && canLoad && window.scrollY + window.innerHeight >= document.body.offsetHeight - 500) {
      loadNextPage();
    }
  });
});